module.exports = __webpack_public_path__ + "img/523.640d1a28.jpg";